export const chartDataKeyPrefix = ['widgetsChartData'];
